import React, { useMemo, useState, useEffect } from "react";
import { useTheme as useAppTheme } from "../contexts/ThemeContext";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Alert,
  CircularProgress,
  Link,
  // Switch,
  // FormControlLabel,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import { createCommonStyles } from "../theme/styles";
import authService from "../services/authService";
import { useNavigate, Link as RouterLink, useParams } from "react-router-dom";
import Logo from "../assets/ZakazujMeLogo4.png";
import { getTenantSubdomain } from "../utils/subdomain";
import userService from "../services/userService";
import tenantService from "../services/tenantService";

const UserRegistration = () => {
  const { isDarkMode } = useAppTheme();
  const commonStyles = createCommonStyles(isDarkMode);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    hasExistingAccount: false,
  });
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState({});
  const [tenantData, setTenantData] = useState({});

  const navigate = useNavigate();
  const params = useParams();
  const tenantSubdomain = useMemo(() => getTenantSubdomain(), []);
  const isTenantSpecificMode = Boolean(tenantSubdomain);

  useEffect(() => {
    const fetchTenantData = async () => {
      if (params.tenantId) {
        try {
          const data = await tenantService.getTenantName(params.tenantId);
          setTenantData(data);
        } catch (error) {
          console.error("Error fetching tenant data:", error);
        }
      }
    };
    fetchTenantData();
  }, [params.tenantId]);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    // Provera da li su sva polja popunjena
    if (form.hasExistingAccount) {
      if (!form.email) {
        setError("Email je obavezan.");
        return;
      }
    } else {
      if (
        !form.firstName ||
        !form.lastName ||
        !form.email ||
        !form.phone ||
        !form.password ||
        !form.confirmPassword
      ) {
        setError("Sva polja su obavezna.");
        return;
      }
      if (form.password !== form.confirmPassword)
        return setError("Lozinke se ne poklapaju.");
    }
    try {
      setIsLoading(true);
      const data = form.hasExistingAccount
        ? {
            email: form.email,
            userType: "customer",
            ...(isTenantSpecificMode && tenantSubdomain
              ? { subdomain: tenantSubdomain }
              : {}),
          }
        : {
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            phone: form.phone,
            password: form.password,
            userType: "customer",
            ...(isTenantSpecificMode && tenantSubdomain
              ? { subdomain: tenantSubdomain }
              : {}),
          };
      //ako je registracija putem linka sa tenantId
      if (params.tenantId) {
        const result = await userService.registerUserViaLink({
          ...data,
          tenantId: params.tenantId,
          hasExistingAccount: form.hasExistingAccount,
        });
        console.log("result", result);
        if (result.error) {
          setError(result.error);
          return;
        }
        setResult(result);
        setTimeout(() => {
          navigate("/login");
        }, 10000);
        return;
      }

      const result = await authService.register(data);
      console.log("result", result);
      setResult(result);
      setTimeout(() => {
        navigate("/login");
      }, 10000);
    } catch (err) {
      console.log("err", err);
      setError(err?.message || "Došlo je do greške. Pokušajte ponovo.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isTenantSpecificMode && !params.tenantId && (
        <Box
          sx={{
            position: "fixed",
            top: 18,
            right: 24,
            display: "flex",
            gap: 2,
            color: "rgba(255,255,255,0.95)",
            fontSize: 18,
            zIndex: 1100,
          }}
        >
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/home"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Početna
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/cooperation"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Saradnja
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/about"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            O nama
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/privacy-policy"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Politika Privatnosti
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/login"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Prijavi se
          </Link>
          <Link
            hidden
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/userregistration"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              background: "linear-gradient(90deg, #3B82F6 0%, #06B6D4 100%)",
              color: "white",
              boxShadow: "0 2px 8px rgba(59,130,246,0.25)",
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "linear-gradient(90deg, #1D4ED8 0%, #06B6D4 100%)",
                color: "#fff",
              },
            }}
          >
            Registruj se
          </Link>
        </Box>
      )}
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: isDarkMode
            ? "linear-gradient(180deg, #0F1431 0%, #171B46 100%)"
            : "#ffffff",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            ...commonStyles.glassContainerMedium,
            p: { xs: 3, sm: 4 },
            maxWidth: 420,
            width: "100%",
            borderRadius: 3,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Box
              component="img"
              src={Logo}
              alt="Zakazuj Logo"
              sx={{ height: 120, objectFit: "contain" }}
            />
          </Box>
          {params.tenantId && tenantData.name && (
            <Typography
              variant="h5"
              sx={{
                color: "rgba(255,255,255,0.95)",
                fontWeight: 900,
                letterSpacing: "-0.02em",
                mb: 1,
                textAlign: "center",
              }}
            >
              {tenantData.name}
            </Typography>
          )}
          <Typography
            variant="h5"
            sx={{
              color: "rgba(255,255,255,0.95)",
              fontWeight: 900,
              letterSpacing: "-0.02em",
              mb: 1,
              textAlign: "center",
            }}
          >
            Registracija korisnika
          </Typography>
          <Typography
            sx={{ color: "rgba(255,255,255,0.75)", mb: 2, textAlign: "center" }}
          >
            Unesite podatke za svoj nalog.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {result && result.user && (
            <Alert
              severity="success"
              sx={{ mb: 2, ...commonStyles.alert("success") }}
            >
              {result.message ||
                "  Uspesno ste se registrovali nalog. Preusmeravanje na stranicu za prijavu..."}
            </Alert>
          )}

          <Box component="form" noValidate onSubmit={handleSubmit}>
            {/* <FormControlLabel
              control={
                <Switch
                  checked={form.hasExistingAccount}
                  onChange={(e) => setForm((p) => ({ ...p, hasExistingAccount: e.target.checked }))}
                  sx={{ color: "rgba(255,255,255,0.85)" }}
                />
              }
              label="Vec imam nalog na drugoj radnji preko Zakazuj platforme"
              sx={{
                color: "rgba(255,255,255,0.85)",
                mb: 2,
                alignItems: "flex-start",
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.875rem",
                  lineHeight: 1.4,
                },
              }}
            /> */}
            {!form.hasExistingAccount && (
              <>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="firstName"
                  name="firstName"
                  label="Ime"
                  value={form.firstName}
                  onChange={handleChange}
                  disabled={isLoading}
                  variant="outlined"
                  sx={commonStyles.formField}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="lastName"
                  name="lastName"
                  label="Prezime"
                  value={form.lastName}
                  onChange={handleChange}
                  disabled={isLoading}
                  variant="outlined"
                  sx={commonStyles.formField}
                  InputLabelProps={{ shrink: true }}
                />
              </>
            )}
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              name="email"
              label="Email"
              type="email"
              value={form.email}
              onChange={handleChange}
              disabled={isLoading}
              variant="outlined"
              sx={commonStyles.formField}
              InputLabelProps={{ shrink: true }}
            />
            {!form.hasExistingAccount && (
              <>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="phone"
                  name="phone"
                  label="Telefon"
                  value={form.phone}
                  onChange={handleChange}
                  disabled={isLoading}
                  variant="outlined"
                  sx={commonStyles.formField}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="password"
                  name="password"
                  label="Lozinka"
                  type={showPwd ? "text" : "password"}
                  autoComplete="new-password"
                  value={form.password}
                  onChange={handleChange}
                  disabled={isLoading}
                  variant="outlined"
                  sx={commonStyles.formField}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPwd((s) => !s)}
                          edge="end"
                          sx={{ color: "rgba(255,255,255,0.85)" }}
                        >
                          {showPwd ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Potvrdi lozinku"
                  type={showConfirm ? "text" : "password"}
                  autoComplete="new-password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  disabled={isLoading}
                  variant="outlined"
                  sx={commonStyles.formField}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={() => setShowConfirm((s) => !s)}
                          edge="end"
                          sx={{ color: "rgba(255,255,255,0.85)" }}
                        >
                          {showConfirm ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isLoading}
              sx={{
                ...commonStyles.gradientButton,
                mt: 2,
                py: 1.25,
                borderRadius: 999,
                fontWeight: 800,
                textTransform: "none",
              }}
            >
              {isLoading ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                "Registruj se"
              )}
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default UserRegistration;
